import { NotesApiService } from '@common/ApiService'
const NOTES_SUCCESS = 'NOTES_SUCCESS'
const NOTE_ERROR = 'ORGANISATION_ERROR'
const NOTE_SUCCESS = 'NOTE_SUCCESS'

export const state = {
  note: {},
  errors: {},
}

export const getters = {}

export const mutations = {
  [NOTES_SUCCESS](state, data) {
    state.notes = data
    return state
  },

  [NOTE_SUCCESS](state, data) {
    state.note = data
    return state
  },

  [NOTE_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },
}

export const actions = {
  createNote({ commit }, newNote) {
    return NotesApiService.post(newNote).then((response) => {
      commit(NOTE_SUCCESS, response.data)
    })
  },
}
